import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { operatorImage } from "@/mocks/home";

const profileRows = [
  { label: "年齢", value: "19歳" },
  { label: "立場", value: "テキサス州のコミュニティカレッジに在籍中の学生" },
  { label: "留学の形", value: "留学エージェントを使わずに自分で出願して渡米" },
  { label: "現在の目標", value: "4年制大学への編入に向けて準備中" },
  { label: "ブログ", value: "note で日々の記録を更新" },
];

const policies = [
  "制度の情報と、運営者個人の体験談は、明確に分けて書きます。",
  "確認できない内容は推測で書かず、「記事準備中」と表示します。",
  "第三者が作成した資料は、転載・再配布が明確に許可されているものだけを使用します。",
  "公式サイトで見られることだけを理由に、転載してよいとは判断しません。",
  "公式情報を紹介するときは、URL・確認日・利用条件を記録します。",
  "AIで生成した画像は、実在の学校の写真と誤解されないようイメージ画像と表記します。",
];

export default function About() {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <SiteHeader />
      <main className="w-full flex-1">
        <section className="w-full border-b border-background-200 bg-background-100">
          <div className="mx-auto w-full max-w-content px-5 py-12 md:px-6 md:py-16">
            <div className="grid items-center gap-10 lg:grid-cols-[38fr_62fr] lg:gap-14">
              <div className="w-full">
                <div className="relative aspect-[4/5] w-full overflow-hidden rounded-xl bg-background-200 shadow-[0_18px_40px_-26px_rgba(23,37,35,0.35)]">
                  <img
                    src={operatorImage}
                    alt="机の上に置かれたノートパソコンとノート、窓の外に広がる大学キャンパス（イメージ画像）"
                    title="留学準備 勉強机 アメリカの大学キャンパス"
                    className="absolute inset-0 h-full w-full object-cover object-top"
                  />
                </div>
                <p className="mt-3 flex items-center gap-1.5 text-[11.5px] text-foreground-500">
                  <i className="ri-image-line text-[13px] text-primary-600" />
                  ※イメージ画像です
                </p>
              </div>

              <div className="w-full">
                <p className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.22em] text-primary-700">
                  <span className="h-[1px] w-6 bg-primary-500" />
                  About
                </p>
                <h1 className="mt-4 font-heading text-[28px] font-bold leading-[1.5] tracking-tight text-foreground-950 md:text-[36px]">
                  運営者について
                </h1>
                <p className="mt-5 text-[13.5px] leading-[2] text-foreground-700 md:text-[14.5px]">
                  はじめまして。このサイトを運営している、テキサス州のコミュニティカレッジに通う19歳の日本人学生です。高校卒業後、留学エージェントを使わずに自分で出願してアメリカへ渡り、現在は4年制大学への編入を目指して準備しています。
                </p>
                <p className="mt-4 text-[13.5px] leading-[2] text-foreground-700 md:text-[14.5px]">
                  編入はまだ経験していません。だからこそ、制度の基本は公式情報を確認しながら整理し、体験したことは「体験した範囲」で書くようにしています。
                </p>

                <dl className="mt-8 divide-y divide-background-200 rounded-[10px] border border-background-200 bg-background-50 px-5">
                  {profileRows.map((row) => (
                    <div key={row.label} className="flex flex-col gap-1 py-3.5 sm:flex-row sm:items-center sm:gap-6">
                      <dt className="w-full shrink-0 text-[12px] font-semibold text-foreground-500 sm:w-[110px]">
                        {row.label}
                      </dt>
                      <dd className="text-[13px] leading-[1.8] text-foreground-800">{row.value}</dd>
                    </div>
                  ))}
                </dl>

                <p className="mt-4 text-[11.5px] leading-[1.8] text-foreground-500">
                  ※通学している学校名、編入候補の大学名は掲載していません。
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50">
          <div className="mx-auto w-full max-w-content px-5 py-14 md:px-6 md:py-16">
            <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-14">
              <div>
                <h2 className="flex items-start gap-3 font-heading text-[20px] font-bold leading-[1.6] text-foreground-950 md:text-[22px]">
                  <span className="mt-[10px] h-[3px] w-6 shrink-0 rounded-full bg-primary-500" />
                  このサイトについて
                </h2>
                <div className="mt-4 space-y-4 text-[13px] leading-[2] text-foreground-700 md:text-[13.5px]">
                  <p>
                    留学エージェントを使わず、費用を抑えてアメリカ留学を目指す人に向けた情報サイトです。当面は、テキサス州のコミュニティカレッジへの留学と、そこから4年制大学への編入を中心に扱っています。
                  </p>
                  <p>
                    無料記事では、制度の基本を誰でも読める形でまとめています。より実践的なチェックリストや学習資料は、将来PDFガイドとして販売することを目標にしていますが、現在は無料情報サイトとして公開している段階です。
                  </p>
                </div>
                <div className="mt-6 flex flex-wrap gap-2.5">
                  {["現役コミカレ生", "エージェント未使用", "編入を目指して準備中"].map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-background-300 bg-background-50 px-3.5 py-1.5 text-[11px] font-medium text-foreground-700"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>

              <div>
                <h2 className="flex items-start gap-3 font-heading text-[20px] font-bold leading-[1.6] text-foreground-950 md:text-[22px]">
                  <span className="mt-[10px] h-[3px] w-6 shrink-0 rounded-full bg-accent-500" />
                  情報公開と著作権の方針
                </h2>
                <ul className="mt-4 space-y-2.5">
                  {policies.map((policy) => (
                    <li
                      key={policy}
                      className="flex items-start gap-2.5 text-[12.5px] leading-[1.9] text-foreground-700"
                    >
                      <i className="ri-check-line mt-[4px] shrink-0 text-[14px] text-primary-600" />
                      {policy}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="mt-12 rounded-[10px] border border-accent-200 bg-accent-50 px-6 py-6">
              <p className="flex items-center gap-2 font-heading text-[14px] font-bold text-accent-900">
                <i className="ri-error-warning-line text-[16px]" />
                誤解しないでほしいこと
              </p>
              <ul className="mt-3 grid gap-2.5 sm:grid-cols-2">
                {[
                  "コミカレから4年制大学への編入は保証されません",
                  "必要なGPA・単位・出願資格は大学や専攻で異なります",
                  "取得した単位がすべて卒業要件に使えるとは限りません",
                  "コミカレ経由が必ず最も安い方法とは限りません",
                  "エージェントを使わなくても学費・出願料・渡航費は必要です",
                  "TSIA2の受験条件・免除条件は個別の確認が必要です",
                  "運営者は現在編入準備中で、編入経験者ではありません",
                ].map((item) => (
                  <li
                    key={item}
                    className="flex items-start gap-2 text-[12px] leading-[1.85] text-foreground-700"
                  >
                    <i className="ri-subtract-line mt-[5px] shrink-0 text-[13px] text-accent-600" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-10 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/learn"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-700 px-6 py-3 text-[13px] font-semibold text-background-50 shadow-sm transition-all duration-200 hover:-translate-y-[2px] hover:bg-primary-800 hover:shadow-md"
              >
                無料記事を読む
                <i className="ri-arrow-right-line text-[14px]" />
              </Link>
              <a
                href="https://note.com/mypace_diary"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-accent-500 bg-background-50 px-6 py-3 text-[13px] font-semibold text-accent-700 transition-all duration-200 hover:-translate-y-[2px] hover:bg-accent-50 hover:shadow-md"
              >
                留学ブログを読む（note）
                <i className="ri-external-link-line text-[14px]" />
              </a>
            </div>
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  );
}